module.exports = __webpack_public_path__ + "static/media/hero-image.bb029672.jpg";